export default __webpack_public_path__ + "static/media/applications.4ccdfb23.svg";